module.exports = __webpack_public_path__ + "static/media/camera-added.1d56a8a3.svg";